export default __webpack_public_path__ + "static/media/aboutus2.21c62f6b.png";